import { Separator } from '@synoptic/ui-kit/separator/separator.js';
import { PrefetchPageLinks } from 'react-router';
import { ItemContent } from 'react-virtuoso';
import {
  CollectionStreamPostFragmentFragment,
  StreamPostCardFragmentFragment,
} from '@/__generated__/graphql.ts';
import { paths } from '@/routes-utils/paths.ts';
import { Feed, FeedProps } from '../feed/feed.tsx';
import { PolymorphicPostCard } from '../polymorphic-post-card.tsx';
import { postFeedGap } from './post-feed.css.ts';

export type FeedItem =
  | StreamPostCardFragmentFragment
  | CollectionStreamPostFragmentFragment;

export type PostFeedProps = Omit<FeedProps<FeedItem, never>, 'itemContent'> & {
  gap?: number;
  itemContent?: ItemContent<FeedItem, never>;
};

const itemContent = (idx: number, post: FeedItem) => (
  <>
    {idx > 0 && post.__typename === 'StreamPost' && <Separator />}
    <PolymorphicPostCard post={post} linkToPost />
  </>
);

export const PostFeed = (props: PostFeedProps) => {
  const initialItemCount =
    props.initialItemCount && props.data
      ? Math.min(props.initialItemCount, props.data.length)
      : 0;

  return (
    <>
      <Feed
        getBackToTopLabel={(n) => `${n} New posts`}
        gap={props.gap || postFeedGap}
        computeItemKey={(_idx, post) => post.id}
        itemContent={itemContent}
        {...props}
        initialItemCount={initialItemCount}
      />
      <PrefetchPageLinks page={paths.post} />
    </>
  );
};
